/**
 * URL base pública del bucket de archivos (ZIPs DICOM, PDFs, audios, logos).
 * Se configura con VITE_MEDIA_BASE_URL. El bucket citamedapp se migró de AWS S3
 * a Cloudflare R2 y se sirve por https://cdn.citamed247.com (2026-10-23).
 * Ese es el default para que un build sin la variable no vuelva a apuntar a AWS.
 */
export const MEDIA_BASE_URL = (
  import.meta.env.VITE_MEDIA_BASE_URL || 'https://cdn.citamed247.com'
).replace(/\/+$/, '');

/**
 * Construye la URL pública de una key del bucket. No codifica: quien llama
 * decide si aplica encodeURI (las rutas que vienen de URL.pathname ya están codificadas).
 */
export const buildMediaUrl = key => `${MEDIA_BASE_URL}/${String(key || '').replace(/^\/+/, '')}`;
